module.exports = __webpack_public_path__ + "img/logo_dark.72a04d70.png";